/* =====================================================================
   assets/ms-set-berater.js · Welche drei Skitouren-Sets passen zu dir
   =====================================================================
   Angelegt am 20.10.2026 (Gesamtliste 2.3). Alex am 20.10.2026: "eine
   kleine ai ... wo man schildert wie gut man ist, oder wie gross man ist
   und wie viel man wiegt oder profi oder anfaenger ... und die ai setzt
   dann die besten 3 sets zusammen", und danach: "am ende qa damit es auch
   wirklich geil funktioniert und nicht so random ist".

   WARUM DIE AUSWAHL HIER STEHT UND NICHT IN DER KI
   Die KI (admin/app/api/set-berater) liest nur die Schilderung des Gastes
   in fuenf Felder: Groesse, Gewicht, Koennen, Einsatz, Modell. Welches Set,
   welche Laenge und welche Bindung, rechnet diese Datei, und zwar immer
   gleich: dieselben Angaben ergeben dieselben drei Sets, jedes mit dem
   Grund daneben. Eine KI, die Sets selbst waehlt, koennte einen Ski
   vorschlagen, den es nicht gibt, eine Laenge ohne Bestand oder einen
   Preis, der nicht stimmt. Hier kommen Preis und Bestand nur aus den
   Varianten, die Shopify in die Seite schreibt.

   DIE REGELN (Faustregeln des Skitourenhandels, mit den Zahlen dazu)
   Laenge   Ziel = Koerpergroesse - 10 cm. Einsteiger -5, Profi +5;
            Einsatz leicht -5, Abfahrt +3; schwer fuer die Groesse
            (Gewicht >= Groesse - 95) +3, leicht (<= Groesse - 115) -3.
            Bis 15 cm daneben anteilig, bis 25 cm mit Abzug und dem Hinweis
            "knapp" (ab 9 cm), darueber nicht.
   Breite   leicht 65 bis 80 mm, Allround 84 bis 90, Abfahrt 94 bis 100;
            innerhalb zaehlt die Naehe zu 70, 87 und 97 mm ein wenig, je
            12 mm ausserhalb faellt die Wertung auf null. Raceski
            (Mitte bis 70 mm) fuer Einsteiger abgewertet.
   Bindung  Race nur fuer leicht und nicht Einsteiger; Freeride (Z 15) fuer
            Abfahrt mit Profi oder ab 85 kg; Tour Z 13 ab 80 kg, fuer
            Profis und Abfahrt; Tour Z 11 fuer alle anderen unter 90 kg.
   Modell   Damen bevorzugt Damenmodelle, Herren schliesst sie aus.
   Gewichtung: Breite 40 %, Laenge 35 %, Bindung 25 %. Gleichstand: die
   naehere Laenge, dann der guenstigere Preis, dann der Name. Je Skimodell (Farben eines Modells
   zaehlen als eines) hoechstens ein Vorschlag.

   Geprueft von tools/pruefung_set_berater.mjs (Testprofile, Gegenproben).
   ===================================================================== */
(function (wurzel) {
  'use strict';

  var BREITE = { leicht: [65, 80], allround: [84, 90], abfahrt: [94, 100] };
  // Innerhalb des Bereichs zaehlt die Naehe zu diesem Punkt ein wenig (je 6 mm 0,1).
  // Nachgetragen am 20.10.2026 nach der Abdeckungspruefung: vorher waren alle Ski im
  // Bereich gleich gut, und den Ausschlag gab der Preis. Der Allrounder (180 cm, 80 kg)
  // bekam dreimal die volle Wertung, und der Rise 84 stand in 100 von 210 Profilen,
  // weil er der guenstigste ist. Fuer "von allem etwas" ist ein 88er der bessere Rat.
  var MITTELPUNKT = { leicht: 70, allround: 87, abfahrt: 97 };

  function zielLaenge(p) {
    var z = p.groesse - 10;
    if (p.koennen === 'einsteiger') z -= 5;
    if (p.koennen === 'profi') z += 5;
    if (p.einsatz === 'leicht') z -= 5;
    if (p.einsatz === 'abfahrt') z += 3;
    if (p.gewicht) {
      if (p.gewicht >= p.groesse - 95) z += 3;
      else if (p.gewicht <= p.groesse - 115) z -= 3;
    }
    return z;
  }

  function breitenklasse(mitte) {
    if (mitte == null) return null;
    if (mitte <= 80) return 'leicht';
    if (mitte >= 92) return 'abfahrt';
    return 'allround';
  }

  function wertBreite(mitte, p) {
    if (mitte == null) return 0.5;
    var r = BREITE[p.einsatz] || BREITE.allround;
    var d = mitte < r[0] ? r[0] - mitte : (mitte > r[1] ? mitte - r[1] : 0);
    var w = d > 0 ? Math.max(0, 1 - d / 12) - 0.1 : 1 - Math.abs(mitte - (MITTELPUNKT[p.einsatz] || 87)) / 60;
    if (mitte <= 70 && p.koennen === 'einsteiger') w = Math.max(0, w - 0.4);
    return w;
  }

  function wertBindung(b, p) {
    var kg = p.gewicht || 0;
    if (!b) return 0.5;
    if (b.art === 'race') return (p.einsatz === 'leicht' && p.koennen !== 'einsteiger') ? 1 : 0.1;
    if (b.art === 'freeride') {
      if (p.einsatz === 'abfahrt' && (p.koennen === 'profi' || kg >= 85)) return 1;
      if (p.einsatz === 'abfahrt') return 0.7;
      return 0.3;
    }
    // Tourenbindung: nach hoechstem Z-Wert
    if (b.z != null && b.z >= 13) return (kg >= 80 || p.koennen === 'profi' || p.einsatz === 'abfahrt') ? 1 : 0.8;
    if (b.z != null) {
      if (kg >= 90) return 0.5;
      return p.koennen === 'profi' ? 0.7 : 1;
    }
    return 0.6;
  }

  function wertModell(geschlecht, p) {
    if (p.modell === 'herren' && geschlecht === 'Damen') return null;
    if (p.modell === 'damen' && geschlecht === 'Damen') return 0.15;
    return 0;
  }

  /* sets: [{id, name, info: {mitte, geschlecht, modell, bindungen: {Option: {id, art, z}}},
             v: [{id, g, b, p, a}]}]
     profil: {groesse, gewicht, koennen, einsatz, modell}
     Antwort: hoechstens drei Vorschlaege, bester zuerst. */
  function empfehlen(sets, profil) {
    var p = {
      groesse: +profil.groesse || 0,
      gewicht: +profil.gewicht || 0,
      koennen: profil.koennen || 'fortgeschritten',
      einsatz: profil.einsatz || 'allround',
      modell: profil.modell || 'egal'
    };
    if (p.groesse < 120 || p.groesse > 215) return [];
    var ziel = zielLaenge(p);
    var je = [];
    sets.forEach(function (s) {
      var info = s.info || {};
      var bonus = wertModell(info.geschlecht, p);
      if (bonus === null) return;
      var wB = wertBreite(info.mitte, p);
      var bester = null;
      (s.v || []).forEach(function (v) {
        if (!v.a) return;
        var laenge = parseInt(v.g, 10);
        if (!laenge) return;
        var abstand = Math.abs(laenge - ziel);
        // Bis 15 cm daneben zaehlt die Laenge anteilig, bis 25 cm bleibt das Set
        // mit null Punkten fuer die Laenge im Rennen und traegt "knapp". Ohne das
        // bekaeme ein Gast mit 155 cm (Ziel 135) gar keinen Vorschlag, weil der
        // kuerzeste Tourenski im Bestand 150 cm misst.
        if (abstand > 25) return;
        // Ueber 15 cm daneben zaehlt jeder weitere Zentimeter gegen das Set (je 10 cm minus 1).
        // Geaendert am 20.10.2026 nach der Nachmessung: mit 0 Punkten ab 15 cm bekam ein Gast mit
        // 198 cm (Ziel 196) einen Blaze 86 in 173 cm vorgeschlagen, 23 cm zu kurz, weil die
        // Laenge nichts mehr zaehlte und die Bindung den Ausschlag gab.
        var wL = abstand <= 15 ? 1 - abstand / 15 : -(abstand - 15) / 10;
        var bindung = (info.bindungen || {})[v.b] || null;
        var wBi = wertBindung(bindung, p);
        var wert = 0.4 * wB + 0.35 * wL + 0.25 * wBi + bonus;
        var k = { set: s, variante: v, bindung: bindung, laenge: laenge, abstand: abstand, knapp: abstand > 8,
                  wert: Math.round(wert * 1000) / 1000,
                  teile: { breite: wB, laenge: wL, bindung: wBi } };
        // Gleichstand: erst die naehere Laenge, dann der Preis. Nachgetragen am 20.10.2026 nach der
        // Nachmessung: bei 198 cm und 105 kg (Ziel 196) lagen alle Laengen ueber 15 cm daneben, alle
        // bekamen 0 Punkte fuer die Laenge, und der Preis waehlte 173 statt 180 cm, waehrend der
        // Grund "die naechste lieferbare Laenge" sagte.
        if (!bester || k.wert > bester.wert || (k.wert === bester.wert && (k.abstand < bester.abstand ||
            (k.abstand === bester.abstand && v.p < bester.variante.p)))) bester = k;
      });
      if (bester) je.push(bester);
    });
    je.sort(function (a, b) {
      return (b.wert - a.wert) || (a.abstand - b.abstand) || (a.variante.p - b.variante.p) || (a.set.name < b.set.name ? -1 : 1);
    });
    var modelle = {}, raus = [];
    for (var i = 0; i < je.length && raus.length < 3; i++) {
      var m = (je[i].set.info && je[i].set.info.modell) || je[i].set.name;
      if (modelle[m]) continue;
      modelle[m] = true;
      raus.push(je[i]);
    }
    return raus.map(function (k) {
      k.ziel = ziel;
      k.klasse = breitenklasse(k.set.info && k.set.info.mitte);
      return k;
    });
  }

  /* Was das Set einzeln kostet: die Preise der zwei Teilvarianten, wie der Shop sie gerade
     verlangt (info.teile_v aus tools/set_berater_daten.py, Preise aus teile[].preise, beide von
     Liquid in die Seite geschrieben). Nachgetragen am 20.10.2026, Alex: "einzeln gekauft X EUR
     dazuschreiben, damit man die Ersparnis sieht, das bringt kunden zum kaufen". Gemessen am
     selben Tag: alle 102 Varianten 39 bis 309 EUR guenstiger als einzeln. Fehlt eine Teilvariante
     oder ihr Preis, gibt es null statt einer halben Summe, und die Seite zeigt nichts: lieber
     keine Ersparnis als eine falsche. Ebenso, wenn das Set nicht guenstiger ist. */
  function einzelpreis(s, v) {
    var ids = s && s.info && s.info.teile_v && s.info.teile_v[String(v.id)];
    if (!ids || !ids.length) return null;
    var summe = 0;
    for (var i = 0; i < ids.length; i++) {
      var preis = null;
      (s.teile || []).forEach(function (t) { if (t.preise && t.preise[String(ids[i])] != null) preis = t.preise[String(ids[i])]; });
      if (preis == null) return null;
      summe += preis;
    }
    return summe > v.p ? summe : null;
  }

  var api = { empfehlen: empfehlen, zielLaenge: zielLaenge, breitenklasse: breitenklasse, einzelpreis: einzelpreis };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else wurzel.MSSetBerater = api;
})(typeof window !== 'undefined' ? window : this);
